import { intersection } from 'lodash';

export const isIntersected = (a: readonly number[], b: readonly number[]) => {
	return intersection(a, b);
};
